import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router";
// const ProfilePicture = require('../images/user.png');
import Tickets from "./Tickets";
import Login from "./Login";
import ProtectedRoute from "./router/ProtectedRoute";
import ContentPage from "./Content";
import Events from "./Events";
import Group from "./Group";
import UserManagement from "./UserManagement";
import Cookies from "js-cookie";

import "./custom.css";
import "antd/dist/antd.css";
import EventPlayers from "./EventPlayers";
import Privacy from "./Tickets/components/Privacy";

const App = () => {
  const role = Cookies.get("role");
  const url = window.location.href;
  const urlArray = url && url.split(".");
  document.title = urlArray[1] ? urlArray[1] : "localhost";
  return (
    <Switch>
      <Route
        path="/login"
        render={() => {
          if (role) {
            return <Redirect to={"/events"} />;
          }
          return <Login />;
        }}
      />
      <Route path={"/privacy"} component={Privacy} />
      <ProtectedRoute exact path={"/contents"} component={ContentPage} />
      <ProtectedRoute exact path={"/events"} component={Events} />
      <ProtectedRoute exact path={"/eventPlayers"} component={EventPlayers} />
      <ProtectedRoute exact path={"/groups"} component={Group} />
      <ProtectedRoute
        exact
        path={"/userManagement"}
        component={UserManagement}
      />
      <Route path={"/"} component={Tickets} />
    </Switch>
  );
};

export default App;
